module.exports = __webpack_public_path__ + "static/media/Thomas-Thilbault.8da073e6.png";